module.exports = __webpack_public_path__ + "media/Fire.7ca0cc66.mp3";